import React, { useState, useEffect } from 'react';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import { Alert, AlertProps } from '@mui/material';

interface Props {
  typeMessage: AlertProps['severity'];
  alertMessage?: string;
  isAlertMessage: boolean;
  handleChangeIsAlertMessage?: () => void;
}

function AlertMessage({ typeMessage, alertMessage, isAlertMessage, handleChangeIsAlertMessage }: Props) {
  const [open, setOpen] = useState(false);
  // CONTRACT: useEffect([isAlertMessage]) syncs open state on every mount and every flag change.
  // CONTRACT: Remount with isAlertMessage=true reopens the snackbar (setOpen(true) fires on mount).
  useEffect(() => {
    setOpen(isAlertMessage);
  }, [isAlertMessage]);

  const handleClose = (event: React.SyntheticEvent | Event, reason: SnackbarCloseReason) => {
    // CONTRACT: reason='clickaway' is silently ignored — no Parent-Reset, no setOpen(false).
    if (reason === 'clickaway') {
      return;
    }
    // CONTRACT: reason='timeout' (auto-hide) → handleChangeIsAlertMessage() UND setOpen(false) BEIDE obligatorisch.
    if (handleChangeIsAlertMessage) {
      handleChangeIsAlertMessage();
    }
    setOpen(false);
  };
  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
    >
      <Alert
        onClose={() => {
          // CONTRACT (RITA-1390): X-Klick muss denselben Parent-Reset auslösen wie Auto-Hide,
          // damit eine erneute identische Meldung wieder erscheint. Clickaway läuft über
          // handleClose (Snackbar) und setzt bewusst NICHT zurück — dieser Pfad hat kein reason.
          if (handleChangeIsAlertMessage) {
            handleChangeIsAlertMessage();
          }
          setOpen(false);
        }}
        severity={typeMessage}
      >
        {/* CONTRACT: alertMessage='' or undefined renders 'Message' as fallback text */}
        {alertMessage || 'Message'}
      </Alert>
    </Snackbar>
  );
}

export default AlertMessage;
